import MainContainer from '../pages/main';

/** Корневая точка маршрутов клиентского приложения. */
export default function IndexRoute() {
  return <MainContainer />;
}
